<script>
  import { t } from 'precompile-intl-runtime';
  import draft from 'stores/Draft';
  import * as draftUtil from 'util/DraftUtil';
  import YarnFillTable from 'components/YarnFillTable/YarnFillTable.svelte';
  import CheckboxInput from 'components/CheckboxInput/CheckboxInput';

  let yarnFillTable;
  let useWarp;
  let useWeft;

  function apply() {
    let threads = yarnFillTable.getThreads();
    if (useWarp || useWeft) {
      draft.update((temp) => {
        if (useWeft) {
          draftUtil.applyColor(temp, threads, 'weft');
        }
        if (useWarp) {
          draftUtil.applyColor(temp, threads, 'warp');
        }
      });
    }
  }
</script>

<div>
  <YarnFillTable bind:this={yarnFillTable} />
  <CheckboxInput label="Apply on warp" bind:checked={useWarp} />
  <CheckboxInput label="Apply on weft" bind:checked={useWeft} />
</div>
<button on:click={apply}>{$t('page.pattern_fill.apply')}</button>
